const isStandaloneMode = (): boolean => {
  const standaloneMedia = window.matchMedia?.('(display-mode: standalone)')?.matches ?? false;
  const standaloneNavigator = (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  return standaloneMedia || standaloneNavigator;
};

const normalizeExternalUrl = (rawUrl: string): string => {
  const trimmedUrl = rawUrl.trim();
  if (!trimmedUrl) return '';
  if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
    return trimmedUrl;
  }
  return `https://${trimmedUrl}`;
};

const toAndroidIntentUrl = (absoluteUrl: string): string => {
  const parsed = new URL(absoluteUrl);
  const scheme = parsed.protocol.replace(':', '') || 'https';
  const route = `${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
  return `intent://${route}#Intent;scheme=${scheme};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(absoluteUrl)};end`;
};

export const openExternalUrl = (rawUrl: string): void => {
  const absoluteUrl = normalizeExternalUrl(rawUrl);
  if (!absoluteUrl) return;

  const isAndroid = /Android/i.test(window.navigator.userAgent);
  if (isAndroid && isStandaloneMode()) {
    window.location.href = toAndroidIntentUrl(absoluteUrl);
    return;
  }

  const externalAnchor = document.createElement('a');
  externalAnchor.href = absoluteUrl;
  externalAnchor.target = '_blank';
  externalAnchor.rel = 'noopener noreferrer external';
  externalAnchor.click();
};
